import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(23 * 3600 + 59 * 60 + 47);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="bg-red-600 text-white py-4 md:py-6 text-center" data-id="element-68">
      <div className="container mx-auto px-4" data-id="element-69">
        <p className="text-xs md:text-sm font-bold uppercase tracking-wider mb-2 md:mb-3 opacity-90" data-id="element-70">
          EL PRECIO DE LANZAMIENTO TERMINA EN:
        </p>
        <div className="flex justify-center items-center gap-1.5 md:gap-4 text-2xl md:text-5xl font-black tabular-nums tracking-tight" data-id="element-71">
          <div className="bg-red-950/30 px-3 py-1.5 md:px-4 md:py-2 rounded-lg min-w-[60px] md:min-w-[100px]" data-id="element-72">
            {hours.toString().padStart(2, '0')}
            <span className="block text-[10px] md:text-xs font-medium uppercase mt-0.5 opacity-70" data-id="element-73">
              Horas
            </span>
          </div>
          <span className="opacity-50 pb-4 md:pb-6" data-id="element-74">:</span>
          <div className="bg-red-950/30 px-3 py-1.5 md:px-4 md:py-2 rounded-lg min-w-[60px] md:min-w-[100px]" data-id="element-75">
            {minutes.toString().padStart(2, '0')}
            <span className="block text-[10px] md:text-xs font-medium uppercase mt-0.5 opacity-70" data-id="element-76">
              Min
            </span>
          </div>
          <span className="opacity-50 pb-4 md:pb-6" data-id="element-77">:</span>
          <div className="bg-red-950/30 px-3 py-1.5 md:px-4 md:py-2 rounded-lg min-w-[60px] md:min-w-[100px]" data-id="element-78">
            {seconds.toString().padStart(2, '0')}
            <span className="block text-[10px] md:text-xs font-medium uppercase mt-0.5 opacity-70" data-id="element-79">
              Seg
            </span>
          </div>
        </div>
        <p className="mt-2 md:mt-4 text-xs md:text-base font-medium" data-id="element-80">
          Después sube $8.000 ARS y no vuelve a bajar.
        </p>
        <div className="max-w-xs md:max-w-md mx-auto mt-3 md:mt-6" data-id="element-81">
          <div className="flex justify-between text-[10px] md:text-xs font-bold mb-1" data-id="element-82">
            <span data-id="element-83">Cupos al precio de lanzamiento</span>
            <span data-id="element-84">68% tomados</span>
          </div>
          <div className="h-1.5 md:h-2 bg-red-950/50 rounded-full overflow-hidden" data-id="element-85">
            <div className="h-full bg-white w-[68%] rounded-full" data-id="element-86"></div>
          </div>
        </div>
      </div>
    </div>;
}